//////////////////////////////////////////
// EXPORT MUTATIONS
/////////////////////////////////////////
export default {
  mUserInfo: (state, { formats, limitations, templates, domain }) => {
    state.limitations = limitations
    state.fontFormat.fontFamily = limitations.fonts[0].label
    state.templates = templates
    state.domain = domain.domain
    state.formatList = formats
  },
  mRestrictedSize: (state, value) => (state.restrictedSize = value),
  mUpdateCurrentFormat: (state, value) => (state.currentFormat = value),
  mUpdateFont: (state, value) => (state.fontFormat = value),
  mUpdateColor: (state, value) => (state.currentColor = value),
  mLoadTemplate: (state, value) => (state.templates = value),
  mAddTemplate: (state, value) => (state.templates = [...state.templates, value]),
  mRemoveTemplate: (state, value) => {
    state.templates = state.templates.filter(item => item.id !== value.id)
  },
  mSetCurrentTemplate: (state, value) => (state.currentTemplate = value),
  mUpdateTemplate: (state, value) => {
    state.templates = state.templates.map(item => {
      if (item.id === value.id) {
        return value
      }
      return item
    })
  },
  mUpdateSaveLocal: (state, value) => (state.canSaveLocal = value),
  mUpdateOpenedMode: (state, value) => (state.openedMode = value),
  mUpdateUpgradeEvent: (state, value) => (state.upgradeEvent = value),
  mUpdateDomain: (state, value) => (state.domain = value),
  mUpdateCloseButton: (state, value) => (state.closeButton = value),
  mUpdateSaveMenuList: (state, value) => (state.saveMenuList = value !== undefined ? value : [])
}



// WEBPACK FOOTER //
// ./src/model/store/mutations.js